<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">

        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="customer-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('customer-type-profile')"
                      to="customer-type-profile">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Perfis de Clientes
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('customer-group')"
                      to="customer-group">
              <i class="lnr-apartment btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Grupos de Clientes
            </t-button>
          </div>

        </div>

        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('customer-type-origin')"
                      to="customer-type-origin">
              <i class="lnr-funnel btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Origem
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-type-quote-status')"
                      to="business-type-quote-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status Orçamentos
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-type-budget-rejection-reason')"
                      to="business-type-budget-rejection-reason">
              <i class="lnr-thumbs-down	btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Motivos Reprovação Orçamento
            </t-button>
          </div>


        </div>

        <div class="no-gutters row">


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-price-list')"
                      to="business-price-list">
              <i class="lnr-book btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tabela de Preços
            </t-button>
          </div>

        </div>

      </div>


    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'ProductsSettings',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
